import Vue from "vue";
import Router from "vue-router";
//import HelloWorld from '@/components/HelloWorld'

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "index",
      component: () => import("@/view/index"),
      children: [
        {
          path: "/",
          name: "home",
          component: () => import("@/view/home/index"),
          meta: {
            title: "N倍科学",
          },
        },
        {
          path: "my",
          name: "my",
          component: () => import("@/view/my/index"),
          meta: {
            title: "个人中心",
          },
        },
        {
          path: "search",
          name: "search",
          component: () => import("@/view/search/search"),
          meta: {
            title: "搜索",
          },
        },
      ],
    },
    {
      path: "/login",
      name: "login",
      component: () => import("@/view/login/index"),
      meta: {},
    },
    {
      path: "/toInvite",
      name: "toInvite",
      component: () => import("@/view/invite/toInvite"),
      meta: {},
    },
    {
      path: "/invite/index",
      name: "invite",
      component: () => import("@/view/invite/index"),
      meta: {},
    },
    {
      path: "/userInfo",
      name: "userInfo",
      component: () => import("@/view/my/userInfo"),
    },
    {
      path: "/wrong",
      name: "wrong",
      component: () => import("@/view/my/wrong"),
      meta: {
        title: "我的错题本",
      },
    },
    {
      path: "/record",
      name: "record",
      component: () => import("@/view/my/record"),
      meta: {
        title: "我的练习",
      },
    },
    {
      path: "/myExam",
      name: "myExam",
      component: () => import("@/view/my/exam"),
      meta: {
        title: "我的考试",
      },
    },
    {
      path: "/examDetail",
      name: "examDetail",
      component: () => import("@/view/my/examDetail"),
      meta: {
        title: "考试详情",
      },
    },
    {
      path: "/myAccount",
      name: "myAccount",
      component: () => import("@/view/my/myAccount"),
      meta: {
        title: "我的账户",
      },
    },
    {
      path: "/bindBank",
      name: "bindBank",
      component: () => import("@/view/my/bindBank"),
      meta: {
        title: "绑定银行卡",
      },
    },
    {
      path: "/withdrawal",
      name: "withdrawal",
      component: () => import("@/view/my/withdrawal"),
      meta: {
        title: "发起提现",
      },
    },
    {
      path: "/testPaperRecordDetail",
      name: "testPaperRecordDetail",
      component: () => import("@/view/my/testPaperRecordDetail"),
    },
    {
      path: "/subject",
      name: "subject",
      component: () => import("@/view/subject/detail"),
      children: [
        {
          path: "detail",
          name: "detail",
          component: () => import("@/view/subject/detail"),
        },
      ],
    },
    {
      path: "/subjectCheck/detail",
      name: "subjectCheck/detail",
      component: () => import("@/view/subjectCheck/detail"),
      meta: {
        title: "专题题目详情",
      },
    },
    {
      path: "/subjectCheck/list",
      name: "subjectCheck/list",
      component: () => import("@/view/subjectCheck/subjectCheckList"),
      meta: {
        title: "专题题目列表",
      },
    },
    {
      path: "/topic/topicList",
      name: "topicList",
      component: () => import("@/view/topic/topicList"),
      meta: {
        title: "试题列表",
      },
    },
    {
      path: "/topic/detail",
      name: "topicDetail",
      component: () => import("@/view/topic/detail"),
      meta: {
        title: "试题详情",
      },
    },
    {
      path: "/topic/topicAnnexDetail",
      name: "topicAnnexDetail",
      component: () => import("@/view/topic/topicAnnexDetail"),
    },
    {
      path: "/topic/postAnswer",
      name: "postAnswer",
      component: () => import("@/view/topic/postAnswer"),
    },

    {
      path: "/subjectList",
      name: "subjectList",
      component: () => import("@/view/subject/subjectList"),
      meta: {
        title: "专题列表",
      },
    },
    {
      path: "/hotSubjectList",
      name: "hotSubjectList",
      component: () => import("@/view/subject/hotSubjectList"),
      meta: {
        title: "热门专题",
      },
    },

    {
      path: "/subject/answers",
      name: "subjectAnswers",
      component: () => import("@/view/subject/answers"),
    },
    {
      path: "/subject/answersResult",
      name: "subjectAnswers",
      component: () => import("@/view/subject/result"),
    },
    {
      path: "/buy",
      name: "buy",
      component: () => import("@/view/subject/buy"),
      meta: {
        title: "购买产品",
      },
    },
    {
      path: "/subject/checkAnnexDetail",
      name: "subjectCheckAnnexDetail",
      component: () => import("@/view/subject/subjectCheckAnnexDetail"),
      meta: {
        title: "题目附件详情",
      },
    },
    {
      path: "/topicList",
      name: "topicList",
      component: () => import("@/view/topicList"),
    },
    {
      path: "/testPaper/testPaperList",
      name: "testPaperList",
      component: () => import("@/view/testPaper/testPaperList"),
    },
    {
      path: "/testPaper/result",
      name: "testPaperResult",
      component: () => import("@/view/testPaper/result"),
    },
    {
      path: "/testPaper/answers",
      name: "testPaperAnswers",
      component: () => import("@/view/testPaper/answers"),
    },
    {
      path: "/articleDetail",
      name: "articleDetail",
      component: () => import("@/view/article/detail"),
      meta: {
        title: "文章详情",
      },
    },
    {
      path: "/articleList",
      name: "articleList",
      component: () => import("@/view/article/index"),
      meta: {
        title: "文章列表",
      },
    },
    {
      path: "/answerItem",
      name: "answerItem",
      component: () => import("@/view/answer/answers"),
    },
    {
      path: "/startAnswer",
      name: "startAnswer",
      component: () => import("@/view/answer/startAnswer"),
    },
    {
      path: "/collect",
      name: "collect",
      component: () => import("@/view/my/collect"),
      meta: {
        title: "我的收藏",
      },
    },
    {
      path: "/search",
      name: "search",
      component: () => import("@/view/search"),
    },
    {
      path: "/searchs",
      name: "searchs",
      component: () => import("@/view/search/search"),
    },
    {
      path: "/parent",
      name: "parent",
      component: () => import("@/view/parent"),
      children: [
        {
          path: "/parent",
          name: "parentHome",
          component: () => import("@/view/parent/home"),
        },
        {
          path: "/parent/my",
          name: "parentMy",
          component: () => import("@/view/parent/my"),
        },
      ],
    },
    {
      path: "/parent/my/seting",
      name: "seting",
      component: () => import("@/view/parent/my/seting"),
    },
    {
      path: "/parent/my/child",
      name: "child",
      component: () => import("@/view/parent/my/child"),
    },
    {
      path: "/subjectExchange/:id",
      name: "subjectExchange",
      component: () => import("@/view/subjectExchange/index"),
    },
    {
      path: "/buyMember",
      name: "buyMember",
      component: () => import("@/view/buyMember/index"),
    },
    {
      path: "/buyProduct",
      name: "buyProduct",
      component: () => import("@/view/buyProduct/index"),
    },
    {
      path: "/buyProxyMember/:agentMemberId",
      name: "buyProxyMember",
      component: () => import("@/view/buyProxyMember/index"),
    },
    {
      path: "/mySubjecList",
      name: "mySubjecList",
      component: () => import("@/view/my/mySubjecList"),
      meta: {
        title: "我的专题",
      },
    },
    {
      path: "/myBuy",
      name: "myBuy",
      component: () => import("@/view/my/myBuy"),
      meta: {
        title: "我的购买",
      },
    },
    {
      path: "/commissionRecord",
      name: "commissionRecord",
      component: () => import("@/view/commissionRecord/index"),
      meta: {
        title: "分佣记录",
      },
    },
    {
      path: "/withdrawalRecord",
      name: "withdrawalRecord",
      component: () => import("@/view/withdrawalRecord/index"),
      meta: {
        title: "提现记录",
      },
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js